import MassInfo from './MassInfo';

export default MassInfo;
